import type { AutoFrameI, FlexFrameI } from "tweenly"
import AbstractContainer from "./AbstractContainer"

interface Props {
    object: AutoFrameI | FlexFrameI
    isHiding: boolean
    isLocking: boolean
    isRootTicker: boolean
    canvasScaleCoef: number
    borderCoef: number
    handleSelectObject: (
        event: React.MouseEvent,
        objectId: string,
        animationIds: string[],
        multiSelectKey: boolean
    ) => void
}

const AutoFrameContainer = ({
    object,
    isHiding,
    isLocking,
    isRootTicker,
    canvasScaleCoef,
    borderCoef,
    handleSelectObject,
}: Props) => {
    return (
        <AbstractContainer
            object={object}
            isHiding={isHiding}
            isLocking={isLocking}
            isRootTicker={isRootTicker}
            canvasScaleCoef={canvasScaleCoef}
            borderCoef={borderCoef}
            handleSelectObject={handleSelectObject}
            className={"auto-frame-container"}
            visibility={object.isHidden || isHiding ? "hidden" : "visible"}
        />
    )
}

export default AutoFrameContainer
